import { useEffect, useState } from "react";
import { Typography, Popover, Tooltip } from "antd";
import { FormattedMessage } from "react-intl";
import { useAuth } from "react-oidc-context";
import { useSelector } from "react-redux";

import UserMenu from "./userMenu";
import { getUser } from "../../../keycloak";
import { saveUserFromKeycloak } from "../../../modules/userSession";

import "./index.css";

const { Text } = Typography;

const defaultClient = "DHL Freight CZ";

const UserInfo = () => {
  const [email, setEmail] = useState();
  const [userName, setUserName] = useState();
  const [clientName, setClientName] = useState(defaultClient);

  const { isAuthenticated } = useAuth();
  const { user } = useSelector((state) => state.session);
  useEffect(() => {
    if (isAuthenticated) {
      if (user && user.email) {
        setEmail(user.email);
        setUserName(user.name || user.email);
        setClientName(user.client || defaultClient);
      } else {
        saveUserFromKeycloak(null, getUser());
      }
    }
  }, [user, isAuthenticated]);
  return isAuthenticated ? (
    <Popover
      trigger="click"
      placement="bottomRight"
      title={
        <FormattedMessage
          id="messages.userMenu"
          defaultMessage="Uživatelské menu"
        />
      }
      content={<UserMenu />}
    >
      <div className="user-info pointer">
        <Tooltip title={email} className="pointer">
          <Text strong>{userName}</Text>
        </Tooltip>
        <Text>{clientName}</Text>
      </div>
    </Popover>
  ) : null;
};

export default UserInfo;
